import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import Dropdown from "react-bootstrap/Dropdown";
import Form from "react-bootstrap/Form";
import { useSelector, useDispatch } from "react-redux";
import { getHistoricalDevices, getLogData } from "./../../Utils/actions/yh";
import { Paper, Tooltip, IconButton } from "@material-ui/core";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { Switch } from "@material-ui/core";
import Stack from "@mui/material/Stack";
import { Edit } from "@material-ui/icons";
import DownloadIcon from "@mui/icons-material/Download";
import DeleteIcon from "@mui/icons-material/Delete";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import DataChannel from "./ConfigForm";
import Typography from "@mui/material/Typography";
import { DataChannel1, complexRules } from "./ConfigForm1";
import {
  configurationData,
  getConfigurationData,
} from "./../../Utils/actions/yh";
import { rigWellData, yhAddress, yhPort, getLog } from "./DqDummy.js";
import { Link, useLocation } from "react-router-dom";
import { getApiUserRoles } from "../../Utils/actions/index.js";

const Configuration = (props) => {
  const location =  useLocation();
  const activeRigId = location.state && location.state.rig;
  const {
    // rigWellData,
    // yhAddress,
    // yhPort,
    // getLog,
    getconfigurationAllData,
  } = useSelector((state) => state.yh);

  const cardData = Object.keys(getconfigurationAllData).map(
    (key) => getconfigurationAllData[key]
  );
  const dispatch = useDispatch();
  const [selectedWell, setSelectedWell] = useState("");
  const [selectedLog, setSelectedLog] = useState("");
  const [addNewChannel, setAddNewChannel] = useState(false);
  const [Data, setData] = useState(cardData);
  const [aspectValues, setAspectValues] = useState({});
  const [showGetCard, setShowGetCard] = useState(true);

  const initialAspectComplexRuleCounts = DataChannel1.reduce(
    (accumulator, item) => {
      return accumulator.concat(Array(item.aspects.length).fill(0));
    },
    []
  );

  useEffect(() => {
    dispatch(getApiUserRoles(sessionStorage.getItem("username")))
},[])

  const [aspectComplexRuleCounts, setAspectComplexRuleCounts] = useState(
    initialAspectComplexRuleCounts
  );

  useEffect(() => {
    // dispatch(getHistoricalDevices(`https://${yhAddress}:${yhPort}`));
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    // dispatch(getLogData(selectedWell, `http://${yhAddress}`));
    //eslint-disable-next-line
  }, [selectedWell]);

  useEffect(() => {
    if (selectedLog) {
      setShowGetCard(true);
      // dispatch(
      //   getConfigurationData(`http://${yhAddress}`, selectedLog.feed_id)
      // );
    }
  }, [selectedLog]);

  useEffect(() => {
    setData(
      Object.keys(getconfigurationAllData).map(
        (key) => getconfigurationAllData[key]
      )
    );
  }, [getconfigurationAllData]);

  const handleWellChange = (event) => {
    setSelectedWell(event.target.value);
  };

  const handleLogChange = (event) => {
    setSelectedLog(event.target.value);
  };

  const downloadData = (data, filename) => {
    const jsonData = JSON.stringify(data, null, 2);
    const blob = new Blob([jsonData], { type: "application/json" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
  };

  const handleCardExport = (cardData) => {
    downloadData([cardData], "card_data.json"); // Pass the card data and desired filename
  };

  const handleExport = () => {
    downloadData(Data, "exported_data.json"); // Pass the data and desired filename
  };

  const handleUploadClick = () => {
    const fileInput = document.createElement("input");
    fileInput.type = "file";
    fileInput.accept = ".json";
    fileInput.style.display = "none";
    fileInput.addEventListener("change", handleFileChange);
    document.body.appendChild(fileInput);
    fileInput.click();
    document.body.removeChild(fileInput);
  };

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      // Create a FileReader to read the content of the selected file.
      const readerFile = new FileReader();

      // Define an event handler for when the file reading is completed.
      readerFile.onload = function (e) {
        const fileContent = e.target.result;

        // Parse the JSON content into a JavaScript object
        const newCardData = JSON.parse(fileContent);

        // Filter out the cards with names that already exist in the Data array
        const existingCardNames = Data.map((item) => item.name);
        const newCards = newCardData.filter(
          (card) => !existingCardNames.includes(card.name)
        );

        // Update the existing cards with the same names
        const updatedData = Data.map((existingCard) => {
          const matchingNewCard = newCardData.find(
            (card) => card.name === existingCard.name
          );
          return matchingNewCard
            ? { ...existingCard, ...matchingNewCard }
            : existingCard;
        });

        // Add new cards and updated cards to the Data array
        setData([...updatedData, ...newCards]);
      };

      // Read the file as text
      readerFile.readAsText(selectedFile);
    }
  };

  const addChannel = () => {
    setAddNewChannel(true);
    setShowGetCard(false);
  };

  const handleInputChange = (aspectCategory, value, fieldName) => {
    setAspectValues((prevAspectValues) => ({
      ...prevAspectValues,
      [aspectCategory]: {
        ...prevAspectValues[aspectCategory],
        [fieldName]: value,
      },
    }));
  };

  const handleSubmit = async () => {
    const newData = {
      name: aspectValues.name.name,
      status: aspectValues.status.status,
      slideBy: aspectValues.slideBy.slideBy,
      windowLength: aspectValues.windowLength.windowLength,
      indexes: [aspectValues.indexes.indexes],
      aspects: [
        {
          name: "frequency",
          status:
            aspectValues.frequency.status !== "enable" ? "disabled" : "enable",
          expectedValue: aspectValues.frequency.expectedValue,
          deltaValue: 10,
          weightage: aspectValues.frequency.weightage,
          ttThreshold: aspectValues.frequency.ttThreshold,
        },
        {
          name: "precision",
          status:
            aspectValues.precision.status !== "enable" ? "disabled" : "enable",
          expectedValue: aspectValues.precision.expectedValue,
          weightage: aspectValues.precision.weightage,
          ttThreshold: aspectValues.precision.ttThreshold,
        },
        {
          name: "dataGap",
          status:
            aspectValues.dataGap.status !== "enable" ? "disabled" : "enable",
          expectedValue: aspectValues.dataGap.expectedValue,
          weightage: aspectValues.dataGap.weightage,
        },
        {
          name: "dataCount",
          status:
            aspectValues.dataCount.status !== "enable" ? "disabled" : "enable",
          expectedValue: aspectValues.dataCount.expectedValue,
          deltaValue: 60,
          ttThreshold: aspectValues.dataCount.ttThreshold,
          weightage: aspectValues.dataCount.weightage,
        },
        {
          name: "latency",
          status:
            aspectValues.latency.status !== "enable" ? "disabled" : "enable",
          expectedValue: aspectValues.latency.expectedValue,
          deltaValue: 60,
          ttThreshold: aspectValues.latency.ttThreshold,
          weightage: aspectValues.latency.weightage,
        },
        {
          name: "minValue",
          status:
            aspectValues.minValue.status !== "enable" ? "disabled" : "enable",
          expectedValue: aspectValues.minValue.expectedValue,
          deltaValue: 2,
          ttThreshold: aspectValues.minValue.ttThreshold,
          weightage: aspectValues.minValue.weightage,
        },
        {
          name: "staleValue",
          status:
            aspectValues.staleValue.status !== "enable" ? "disabled" : "enable",
          ttThreshold: aspectValues.staleValue.ttThreshold,
          weightage: aspectValues.staleValue.weightage,
        },
        {
          name: "maxValue",
          status:
            aspectValues.maxValue.status !== "enable" ? "disabled" : "enable",
          expectedValue: aspectValues.maxValue.expectedValue,
          weightage: aspectValues.maxValue.weightage,
          ttThreshold: aspectValues.maxValue.ttThreshold,
          complexRules: [
            {
              mnemonics: "Bit_Depth,Hole_depth",
              validateCondition: "($Hole_depth - $Bit_Depth) > 30",
              onSuccess: "#2",
              onFailure: "#3",
              id: "1",
            },
            {
              mnemonics: "RPM",
              validateCondition: "$RPM=1",
              onSuccess: "#3",
              onFailure: "=exit",
              id: "2",
            },
            {
              mnemonics: "FlowIn",
              validateCondition: "$FlowIn > 34",
              onSuccess: "continue",
              onFailure: "exit",
              id: "3",
            },
          ],
        },
      ],
    };

    try {
      const jsonString = JSON.stringify(newData);
      const newDataJSON = JSON.parse(jsonString);

      // await dispatch(
      //   configurationData(
      //     `http://${yhAddress}`,
      //     selectedLog.feed_id,
      //     newDataJSON
      //   )
      // );

      setAddNewChannel(false);
      setShowGetCard(true);

      // await dispatch(
      //   getConfigurationData(`http://${yhAddress}`, selectedLog.feed_id)
      // );
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleSwitch = (category, field) => {
    // Check the current value of the field
    const currentStatus =
      aspectValues[category] && aspectValues[category][field];

    // Toggle the value between 'enable' and 'disabled'
    const newStatus = currentStatus === "enable" ? "disabled" : "enable";

    // Update the aspectValues state with the new status
    setAspectValues((prevAspectValues) => ({
      ...prevAspectValues,
      [category]: {
        ...prevAspectValues[category],
        [field]: newStatus,
      },
    }));
  };

  const handleAddButton = (aspectIndex) => {
    setAspectComplexRuleCounts((prevCounts) => {
      const updatedCounts = [...prevCounts];
      updatedCounts[aspectIndex]++;
      return updatedCounts;
    });
  };

  const handleRemoveButton = (aspectIndex, ruleIndex1) => {
    setAspectComplexRuleCounts((prevCounts) => {
      const ruleIndex11 = [];

      ruleIndex11.push(ruleIndex1);

      const updatedCounts = [...prevCounts];
      updatedCounts[aspectIndex]--;
      return updatedCounts;
    });
  };

  // const updatedCounts = aspectComplexRuleCounts.filter((_, index) => index !== ruleIndex1);
  // setAspectComplexRuleCounts(updatedCounts);

  return (
    <>
      <Paper id="chartContainer">
        {showGetCard && (
          <>
            <div className="d-flex justify-content-between">
              <div className="d-flex">
                <Link to="/dq">
                  <FontAwesomeIcon
                    icon={faArrowLeft}
                    variant="contained"
                    className="mr-4"
                    cursor="pointer"
                    style={{
                      fontSize: "23px",
                      marginTop: "6px",
                      color: "rgb(32 110 149)",
                    }}
                  />
                </Link>

                <div className="mr-2">
                  <FormControl
                    style={{ width: "150px", padding: "0 !important" }}
                    className="dropdownHeight"
                  >
                    <InputLabel>Select a well</InputLabel>
                    <Select
                      value={selectedWell}
                      onChange={handleWellChange}
                      label="Select a well"
                    >
                      {rigWellData[activeRigId]?.map((well) => (
                        <MenuItem key={well} value={well}>
                          {well}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>

                <div>
                  <FormControl
                    style={{ width: "150px" }}
                    className="dropdownHeight"
                  >
                    <InputLabel>Select a log</InputLabel>
                    <Select
                      value={selectedLog}
                      onChange={handleLogChange}
                      label="Select a log"
                    >
                      {getLog.Records?.map((log) => (
                        <MenuItem key={log} value={log}>
                          {log.logid}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>

                {/* <div className="mr-2">




    <TextField

        select
        label="Select a well"
        variant="standard"
        style={{ margin: '5px', width: "150px" }}
        value={selectedWell}
        onChange={handleWellChange}
    >
        {rigWellData[activeRigId]?.map((well) => (
            <MenuItem key={well} value={well}>
                {well}
            </MenuItem>
        ))}
    </TextField></div>
    <div>
    <TextField

        select
        label="Select a log"
        variant="standard"
        style={{ margin: '5px', width: "150px" }}
        value={selectedLog}
        onChange={handleLogChange}

        className="ml-2"
    >
        {getLog.Records?.map((log) => (
            <MenuItem key={log} value={log}>
                {log.logid}
            </MenuItem>


        ))}
    </TextField>

</div> */}
              </div>
              <div>
                <Button
                  onClick={handleUploadClick}
                  className="mr-2"
                  style={{ backgroundColor: "#1a6481", border: 'none', color: '#fff', boxShadow: 'none' }}
                >
                  Upload
                </Button>
                <Button
                  onClick={handleExport}
                  style={{ backgroundColor: "#1a6481", border: 'none', color: '#fff', boxShadow: 'none' }}
                  className="mr-2"
                >
                  Export
                </Button>
                {/* <Button style={{ backgroundColor: "#092c74" }} onClick={addChannel}>Add Channel</Button> */}
                {selectedLog ? (
                  <Button
                    style={{ backgroundColor: "#1a6481", border: 'none', color: '#fff', boxShadow: 'none' }}
                    onClick={addChannel}
                  >
                    Add Channel
                  </Button>
                ) : null}
              </div>
            </div>

            <div className="row mt-4">
              {Data.map((item, index) => (
                <div key={index} className="col-md-3 mb-3">
                  <Card>
                    <Card.Body>
                      <div className="d-flex justify-content-between">
                        <Card.Title>{item.name}</Card.Title>
                        <div>
                          <Tooltip title={"Download"}>
                            <IconButton
                              className={"mx-1"}
                              size="small"
                              onClick={() => handleCardExport(item)}
                            >
                              <DownloadIcon />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title={"Edit"}>
                            <IconButton className={"mx-1"} size="small">
                              <Edit />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title={"Delete"}>
                            <IconButton className={"mx-1"} size="small">
                              <DeleteIcon />
                            </IconButton>
                          </Tooltip>
                        </div>
                      </div>

                      <Card.Text>
                        <div className="d-flex">
                          <Form.Label>Status:</Form.Label>
                          <Stack style={{ marginTop: "-6px" }}>
                            <Switch color="primary" />
                          </Stack>
                        </div>

                        {item.aspects.map((aspect, index) => (
                          <Card style={{ marginBottom: "10px" }}>
                            <Card.Body>
                              <Card.Title>{aspect.name}</Card.Title>
                              <div key={index}>
                                {Object.keys(aspect)
                                  .filter(
                                    (key) =>
                                      key !== "name" &&
                                      key !== "deltaValue" &&
                                      key !== "complexRules"
                                  )
                                  .map((key) => (
                                    <Card.Text
                                      key={key}
                                      style={{ marginBottom: "0px" }}
                                    >
                                      {`${key}: ${aspect[key]}`}
                                    </Card.Text>
                                  ))}
                              </div>
                            </Card.Body>
                          </Card>
                        ))}
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </div>
              ))}
            </div>
          </>
        )}

        {addNewChannel && (
          <>
            <FontAwesomeIcon
              icon={faArrowLeft}
              variant="contained"
              className="mr-4"
              cursor="pointer"
              style={{ fontSize: "23px", marginTop: "6px", color: "rgb(32 110 149)" }}
              onClick={() => {
                setShowGetCard(true);
                setAddNewChannel(false);
              }}
            />

            <div className="d-flex">
              <Box
                component="form"
                sx={{
                  "& .MuiTextField-root": { m: 1, width: "25ch" },
                }}
                noValidate
                autoComplete="off"
              >
                <div>
                  {DataChannel1.map((details, index) => (
                    <div key={index}>
                      {Object.keys(details).map((key) => {
                        if (key !== "aspects") {
                          if (Array.isArray(details[key])) {
                            return (
                              <>
                                <TextField
                                  key={key}
                                  id={`standard-select-${key}`}
                                  select
                                  label={key}
                                  variant="standard"
                                  style={{ margin: "5px" }}
                                  value={aspectValues[details[key]]}
                                  onChange={(e) =>
                                    handleInputChange(key, e.target.value, key)
                                  }
                                >
                                  {details[key][0].options.map(
                                    (option, optionIndex) => (
                                      <MenuItem
                                        key={optionIndex}
                                        value={option}
                                      >
                                        {option}
                                      </MenuItem>
                                    )
                                  )}
                                </TextField>
                                <br />
                              </>
                            );
                          }
                          //  else if (details[key].type === "select") {
                          //     return (
                          //         <TextField
                          //             key={key}
                          //             id={`standard-select-${key}`}
                          //             select
                          //             label={key}
                          //             variant="standard"
                          //             style={{ margin: '5px' }}
                          //             value={aspectValues[details[key]]}
                          //             onChange={(e) => handleInputChange(key, e.target.value, key)}
                          //         >
                          //             {details[key].options.map((option, optionIndex) => (
                          //                 <MenuItem key={optionIndex} value={option}>
                          //                     {option}
                          //                 </MenuItem>
                          //             ))}
                          //         </TextField>
                          //     );
                          // }
                          else {
                            return (
                              <>
                                <TextField
                                  key={key}
                                  id={`standard-required-${key}`}
                                  label={key}
                                  type={details[key].type}
                                  variant="standard"
                                  style={{ margin: "5px" }}
                                  value={aspectValues[details[key]]}
                                  onChange={(e) =>
                                    handleInputChange(key, e.target.value, key)
                                  }
                                />
                                <br />
                              </>
                            );
                          }
                        }
                      })}
                    </div>
                  ))}
                </div>
              </Box>

              <div>
                {DataChannel1.map((item) =>
                  item.aspects.map((aspect, aspectIndex) => (
                    <Card key={aspectIndex}>
                      <Card.Body>
                        <div className="d-flex justify-content-between">
                          <Card.Title>{aspect.category}</Card.Title>
                          <Card.Text>
                            <Stack
                              direction="row"
                              alignItems="center"
                              className="mr-2"
                            >
                              <Typography>disabled</Typography>
                              {aspect.status &&
                                aspect.status.type === "boolean" && (
                                  <Switch
                                    checked={
                                      aspectValues[aspect.category] &&
                                      aspectValues[aspect.category].status ===
                                        "enable"
                                    }
                                    color="primary"
                                    onClick={() =>
                                      handleSwitch(aspect.category, "status")
                                    }
                                  />
                                )}
                              <Typography>enable</Typography>
                            </Stack>
                          </Card.Text>
                        </div>

                        <Button onClick={() => handleAddButton(aspectIndex)}>
                          Add
                        </Button>

                        <div key={aspectIndex}>
                          {aspect.fields.map((field, fieldIndex) => {
                            return (
                              <TextField
                                key={fieldIndex}
                                id="standard-required"
                                label={field.label}
                                type={field.type}
                                variant="standard"
                                style={{ margin: "5px" }}
                                value={
                                  aspectValues[aspect.category] &&
                                  aspectValues[aspect.category][field.label]
                                }
                                onChange={(e) =>
                                  handleInputChange(
                                    aspect.category,
                                    e.target.value,
                                    field.label
                                  )
                                }
                              />
                            );
                          })}
                        </div>

                        {Array.from({
                          length: aspectComplexRuleCounts[aspectIndex],
                        }).map((_, ruleIndex1) => (
                          <Card key={ruleIndex1}>
                            <Card.Body>
                              <Card.Text>Complex Rules</Card.Text>
                              {complexRules.map((rule, ruleIndex) => (
                                <TextField
                                  key={ruleIndex}
                                  id="standard-required"
                                  label={rule.label}
                                  type={rule.type}
                                  variant="standard"
                                  style={{ margin: "5px" }}
                                />
                              ))}
                              <Button
                                onClick={() =>
                                  handleRemoveButton(aspectIndex, ruleIndex1)
                                }
                              >
                                Remove
                              </Button>
                            </Card.Body>
                          </Card>
                        ))}
                      </Card.Body>
                    </Card>
                  ))
                )}
              </div>
            </div>
            <Button onClick={handleSubmit}>Submit</Button>
          </>
        )}
      </Paper>
    </>
  );
};

export default Configuration;

{
  /* <div key={aspectIndex}>
{aspect.fields.map((field, fieldIndex) => {
    if (field.label === "complexRules") {
        return (
            <div key={fieldIndex}>
                <Button>Add</Button>
                <Card>
                    <Card.Body>
                        <Card.Text>
                            {field.label}
                        </Card.Text>
                        {field.complexRules.map((rule, ruleIndex) => (

                            <TextField
                                key={ruleIndex}
                                id="standard-required"
                                label={rule.label}
                                type={rule.type}
                                variant="standard"
                                style={{ margin: '5px' }}
                                value={aspectValues[aspect.category] && aspectValues[aspect.category][rule.label]}
                                onChange={(e) => handleInputChange(aspect.category, e.target.value, rule.label)}

                            />

                        ))}
                        <Button>Delete</Button>
                    </Card.Body>
                </Card>

            </div>
        );
    } else {
        return (
            
            <TextField
                key={fieldIndex}
                id="standard-required"
                label={field.label}
                type={field.type}
                variant="standard"
                style={{ margin: '5px' }}
                value={aspectValues[aspect.category] && aspectValues[aspect.category][field.label]}
                onChange={(e) => handleInputChange(aspect.category, e.target.value, field.label)}
            />
        );
    }
})}
</div> */
}

// {addNewChannel && <>
//     <div className="d-flex">
//         <Box
//             component="form"
//             sx={{
//                 "& .MuiTextField-root": { m: 1, width: "25ch" }
//             }}
//             noValidate
//             autoComplete="off"
//         >

//             <div>

//                 <TextField
//                     id="standard-required"
//                     label="name"
//                     variant="standard"
//                 />
//                 <br />
//                 <TextField
//                     id="standard-select-status"
//                     select
//                     label="Status"
//                     variant="standard"
//                 //   value={selectedStatus}
//                 //   onChange={handleStatusChange}
//                 >
//                     <MenuItem value="enable">enable</MenuItem>
//                     <MenuItem value="disabled">disabled</MenuItem>
//                 </TextField>
//                 <br />

//                 <TextField
//                     id="standard-required"
//                     label="slideBy"
//                     type="number"
//                     variant="standard"
//                 />
//                 <br />

//                 <TextField
//                     id="standard-required"
//                     label="windowLength"
//                     type="number"
//                     variant="standard"
//                 />
//                 <br />

//                 <TextField
//                     id="standard-select-indexes"
//                     select
//                     label="Indexes"
//                     variant="standard"
//                 >
//                     {Array.from(new Set(Data.flatMap(item => item.indexes))).map(index => (
//                         <MenuItem key={index} value={index}>
//                             {index}
//                         </MenuItem>
//                     ))}
//                 </TextField>
//             </div>
//         </Box>

//         <div>
//             {Data.map((item) => item.aspects.map((aspect, index) => (
//                 <Card key={index}>
//                     <Card.Body>
//                         <div className="d-flex justify-content-between">
//                             <Card.Title>{aspect.name}</Card.Title>
//                             <Card.Text>
//                                 <Stack direction="row" alignItems="center" className="mr-2">
//                                     <Typography >enable</Typography>
//                                     <Switch
//                                         //   checked={isInverted}
//                                         color="primary"

//                                     />
//                                     <Typography>disabled</Typography>
//                                 </Stack>
//                             </Card.Text></div>
//                         {Object.keys(aspect).filter((key) => key !== 'status' && key !== 'name' && key !== 'deltaValue').map((key) => (
//                             <TextField
//                                 key={key}
//                                 id="standard-required"
//                                 label={key}
//                                 type="number"
//                                 variant="standard"
//                                 style={{ margin: '5px' }}
//                             />

//                         ))}
//                     </Card.Body>
//                 </Card>
//             )))}
//         </div>

//     </div>
// </>}

{
  /* <div>
{Data.map((item) => item.aspects.map((aspect, index) => (
    <Card key={index}>
        <Card.Body>
            <div className="d-flex justify-content-between">
                <Card.Title>{aspect.name}</Card.Title>
                <Card.Text>
                    <Stack direction="row" alignItems="center" className="mr-2">
                        <Typography >enable</Typography>
                        <Switch
                            //   checked={isInverted}
                            color="primary"

                        />
                        <Typography>disabled</Typography>
                    </Stack>
                </Card.Text></div>
            {Object.keys(aspect).filter((key) => key !== 'status' && key !== 'name' && key !== 'deltaValue').map((key) => (
                <TextField
                    key={key}
                    id="standard-required"
                    label={key}
                    type="number"
                    variant="standard"
                    style={{ margin: '5px' }}
                    value={DataChannel1.expectedValue}
                    onChange={handleInputChange}
                    name="expectedValue"
                    
                />

            ))}

        </Card.Body>
    </Card>
)))}
</div> */
}

{
  /* <TextField
                                    id="standard-required"
                                    label="name"
                                    variant="standard"
                                />
                                <br />
                                <TextField
                                    id="standard-select-status"
                                    select
                                    label="Status"
                                    variant="standard"
                                //   value={selectedStatus}
                                //   onChange={handleStatusChange}
                                >
                                    <MenuItem value="enable">enable</MenuItem>
                                    <MenuItem value="disabled">disabled</MenuItem>
                                </TextField>
                                <br />



                                <TextField
                                    id="standard-required"
                                    label="slideBy"
                                    type="number"
                                    variant="standard"
                                />
                                <br />

                                <TextField
                                    id="standard-required"
                                    label="windowLength"
                                    type="number"
                                    variant="standard"
                                />
                                <br />

                                <TextField
                                    id="standard-select-indexes"
                                    select
                                    label="Indexes"
                                    variant="standard"
                                >
                                    {Array.from(new Set(Data.flatMap(item => item.indexes))).map(index => (
                                        <MenuItem key={index} value={index}>
                                            {index}
                                        </MenuItem>
                                    ))}
                                </TextField> */
}

{
  /* {addNewChannel && <>
                    <div className="d-flex">

                        <Box
                            component="form"
                            sx={{
                                "& .MuiTextField-root": { m: 1, width: "25ch" }
                            }}
                            noValidate
                            autoComplete="off"
                        >

                            <div>

                                <TextField
                                    name="name"
                                    id="standard-required"
                                    label="Name"
                                    variant="standard"
                                    value={formData.name}
                                    onChange={handleInputChange}
                                />
                                <br />
                                <TextField
                                    id="standard-select-status"
                                    select
                                    label="Status"
                                    variant="standard"
                                    value={formData.status}
                                    onChange={handleInputChange}
                                    name="status"

                                >
                                    <MenuItem value="enable">enable</MenuItem>
                                    <MenuItem value="disabled">disabled</MenuItem>
                                </TextField>

                                <br />

                                <TextField
                                    id="standard-required"
                                    label="Slide By"
                                    type="number"
                                    variant="standard"
                                    value={formData.slideBy}
                                    onChange={handleInputChange}
                                    name="slideBy"
                                />
                                <br />

                                <TextField
                                    id="standard-required"
                                    label="Window Length"
                                    type="number"
                                    variant="standard"
                                    value={formData.windowLength}
                                    onChange={handleInputChange}
                                    name="windowLength"
                                />
                                <br />

                                <TextField
                                    id="standard-select-status"
                                    select
                                    label="Indexes"
                                    variant="standard"
                                    value={formData.indexes}
                                    onChange={handleInputChange}
                                    name="indexes"
                                //   value={selectedStatus}
                                //   onChange={handleStatusChange}
                                >
                                    <MenuItem value="aswi">aswi</MenuItem>
                                    <MenuItem value="dqi">dqi</MenuItem>
                                </TextField>
                            </div>
                        </Box>

                        <div>
                            <Card>
                                <Card.Body>
                                    <div className="d-flex justify-content-between">
                                        <Card.Title>Frequency</Card.Title>
                                        <Card.Text>
                                            <Stack direction="row" alignItems="center" className="mr-2">
                                                <Typography >enable</Typography>
                                                <Switch
                                                    //   checked={isInverted}
                                                    color="primary"

                                                />
                                                <Typography>disabled</Typography>
                                            </Stack>
                                        </Card.Text></div>

                                    <TextField
                                        id="standard-required"
                                        label="Expected Value"
                                        type="number"
                                        variant="standard"
                                        style={{ margin: '5px' }}
                                        value={formData.expectedValue}
                                    onChange={handleInputChange}
                                    name="expectedValue"
                                    />
                                    <TextField
                                        id="standard-required"
                                        label="Weightage"
                                        type="number"
                                        variant="standard"
                                        style={{ margin: '5px' }}
                                        value={formData.weightage}
                                    onChange={handleInputChange}
                                    name="weightage"
                                    />
                                    <TextField
                                        id="standard-required"
                                        label="tt Threshold"
                                        type="number"
                                        variant="standard"
                                        style={{ margin: '5px' }}
                                    />

                                </Card.Body>
                            </Card>

                            <Card>
                                <Card.Body>
                                    <div className="d-flex justify-content-between">
                                        <Card.Title>Precision</Card.Title>
                                        <Card.Text>
                                            <Stack direction="row" alignItems="center" className="mr-2">
                                                <Typography >enable</Typography>
                                                <Switch
                                                    //   checked={isInverted}
                                                    color="primary"

                                                />
                                                <Typography>disabled</Typography>
                                            </Stack>
                                        </Card.Text></div>

                                    <TextField
                                        id="standard-required"
                                        label="Expected Value"
                                        type="number"
                                        variant="standard"
                                        style={{ margin: '5px' }}
                                    />
                                    <TextField
                                        id="standard-required"
                                        label="Weightage"
                                        type="number"
                                        variant="standard"
                                        style={{ margin: '5px' }}
                                    />
                                    <TextField
                                        id="standard-required"
                                        label="tt Threshold"
                                        type="number"
                                        variant="standard"
                                        style={{ margin: '5px' }}
                                    />

                                </Card.Body>
                            </Card>

                            <Card>
                                <Card.Body>
                                    <div className="d-flex justify-content-between">
                                        <Card.Title>Data Gap</Card.Title>
                                        <Card.Text>
                                            <Stack direction="row" alignItems="center" className="mr-2">
                                                <Typography >enable</Typography>
                                                <Switch
                                                    //   checked={isInverted}
                                                    color="primary"

                                                />
                                                <Typography>disabled</Typography>
                                            </Stack>
                                        </Card.Text></div>

                                    <TextField
                                        id="standard-required"
                                        label="Expected Value"
                                        type="number"
                                        variant="standard"
                                        style={{ margin: '5px' }}
                                    />
                                    <TextField
                                        id="standard-required"
                                        label="Weightage"
                                        type="number"
                                        variant="standard"
                                        style={{ margin: '5px' }}
                                    />


                                </Card.Body>
                            </Card>

                            <Card>
                                <Card.Body>
                                    <div className="d-flex justify-content-between">
                                        <Card.Title>Data Count</Card.Title>
                                        <Card.Text>
                                            <Stack direction="row" alignItems="center" className="mr-2">
                                                <Typography >enable</Typography>
                                                <Switch
                                                    //   checked={isInverted}
                                                    color="primary"

                                                />
                                                <Typography>disabled</Typography>
                                            </Stack>
                                        </Card.Text></div>

                                    <TextField
                                        id="standard-required"
                                        label="Expected Value"
                                        type="number"
                                        variant="standard"
                                        style={{ margin: '5px' }}
                                    />
                                    <TextField
                                        id="standard-required"
                                        label="tt Threshold"
                                        type="number"
                                        variant="standard"
                                        style={{ margin: '5px' }}
                                    />
                                    <TextField
                                        id="standard-required"
                                        label="Weightage"
                                        type="number"
                                        variant="standard"
                                        style={{ margin: '5px' }}
                                    />


                                </Card.Body>
                            </Card>

                            <Card>
                                <Card.Body>
                                    <div className="d-flex justify-content-between">
                                        <Card.Title>Latency</Card.Title>
                                        <Card.Text>
                                            <Stack direction="row" alignItems="center" className="mr-2">
                                                <Typography >enable</Typography>
                                                <Switch
                                                    //   checked={isInverted}
                                                    color="primary"

                                                />
                                                <Typography>disabled</Typography>
                                            </Stack>
                                        </Card.Text></div>

                                    <TextField
                                        id="standard-required"
                                        label="Expected Value"
                                        type="number"
                                        variant="standard"
                                        style={{ margin: '5px' }}
                                    />
                                    <TextField
                                        id="standard-required"
                                        label="tt Threshold"
                                        type="number"
                                        variant="standard"
                                        style={{ margin: '5px' }}
                                    />
                                    <TextField
                                        id="standard-required"
                                        label="Weightage"
                                        type="number"
                                        variant="standard"
                                        style={{ margin: '5px' }}
                                    />


                                </Card.Body>
                            </Card>

                            <Card>
                                <Card.Body>
                                    <div className="d-flex justify-content-between">
                                        <Card.Title>Min Value</Card.Title>
                                        <Card.Text>
                                            <Stack direction="row" alignItems="center" className="mr-2">
                                                <Typography >enable</Typography>
                                                <Switch
                                                    //   checked={isInverted}
                                                    color="primary"

                                                />
                                                <Typography>disabled</Typography>
                                            </Stack>
                                        </Card.Text></div>

                                    <TextField
                                        id="standard-required"
                                        label="Expected Value"
                                        type="number"
                                        variant="standard"
                                        style={{ margin: '5px' }}
                                    />
                                    <TextField
                                        id="standard-required"
                                        label="tt Threshold"
                                        type="number"
                                        variant="standard"
                                        style={{ margin: '5px' }}
                                    />
                                    <TextField
                                        id="standard-required"
                                        label="Weightage"
                                        type="number"
                                        variant="standard"
                                        style={{ margin: '5px' }}
                                    />


                                </Card.Body>
                            </Card>

                            <Card>
                                <Card.Body>
                                    <div className="d-flex justify-content-between">
                                        <Card.Title>Stale Value</Card.Title>
                                        <Card.Text>
                                            <Stack direction="row" alignItems="center" className="mr-2">
                                                <Typography >enable</Typography>
                                                <Switch
                                                    //   checked={isInverted}
                                                    color="primary"

                                                />
                                                <Typography>disabled</Typography>
                                            </Stack>
                                        </Card.Text></div>

                                    <TextField
                                        id="standard-required"
                                        label="tt Threshold"
                                        type="number"
                                        variant="standard"
                                        style={{ margin: '5px' }}
                                    />
                                    <TextField
                                        id="standard-required"
                                        label="Weightage"
                                        type="number"
                                        variant="standard"
                                        style={{ margin: '5px' }}
                                    />


                                </Card.Body>
                            </Card>

                            <Card>
                                <Card.Body>
                                    <div className="d-flex justify-content-between">
                                        <Card.Title>Max Value</Card.Title>
                                        <Card.Text>
                                            <Stack direction="row" alignItems="center" className="mr-2">
                                                <Typography >enable</Typography>
                                                <Switch
                                                    //   checked={isInverted}
                                                    color="primary"

                                                />
                                                <Typography>disabled</Typography>
                                            </Stack>
                                        </Card.Text></div>

                                    <TextField
                                        id="standard-required"
                                        label="Expected Value"
                                        type="number"
                                        variant="standard"
                                        style={{ margin: '5px' }}
                                    />
                                    <TextField
                                        id="standard-required"
                                        label="Weightage"
                                        type="number"
                                        variant="standard"
                                        style={{ margin: '5px' }}
                                    />
                                    <TextField
                                        id="standard-required"
                                        label="tt Threshold"
                                        type="number"
                                        variant="standard"
                                        style={{ margin: '5px' }}
                                    />
                                    <TextField
                                        id="standard-required"
                                        label="Complex Rules"
                                        type="number"
                                        variant="standard"
                                        style={{ margin: '5px' }}
                                    />

                                </Card.Body>
                            </Card>



                        </div>

                    </div>
                    <Button onClick={handleSubmit} className="mr-2" style={{ backgroundColor: "#092c74" }}>Submit</Button>

                </>}  */
}
